import { mapActions, mapGetters } from 'vuex'

import SheetWrapper from '@/components/SheetWrapper/index'
import MainButton from '@/components/MainButton'
import PlainSelectField from '@/components/PlainSelectField'
import ResponseDialog from '@/components/ResponseDialog'

import { formatTimestamp, formatTo } from '@/utils/dateHelpers'

export default {
  name: 'round',
  props: {
    roundId: String,
    pageArr: Object
  },
  components: {
    SheetWrapper,
    MainButton,
    PlainSelectField,
    ResponseDialog
  },
  data: () => ({
    displayFixtures: null,
    moveFixtures: [],
    moveGameDialog: false,
    moveGameResponseDialog: false,
    moveGameResponseDialogText: '',
    chosenRound: null
  }),
  computed: {
    ...mapGetters('admin', {
      roundFixtures: 'GET_ROUND_FIXTURES',
      selectToggle: 'GET_SELECT_TOGGLE',
      moveFixturesLoading: 'GET_MOVE_FIXTURES_LOADING',
      moveFixturesResponse: 'GET_MOVE_FIXTURES_STATUS',
      triggerMoveButton: 'GET_TRIGGER_MOVE_BUTTON'
    })
  },
  methods: {
    ...mapActions('admin', {
      fetchRoundFixtures: 'FETCH_ROUND_FIXTURES',
      setSelectToggle: 'TOGGLE_SELECT',
      moveFixturesRequest: 'MOVE_FIXTURES'
    }),
    ...mapActions('admin', ['SET_SHOW_SELECT_BUTTON']),
    ...mapActions(['SET_SHOW_CANCEL_BUTTON']),
    formatToRoundFixture(date) {
      return formatTo({
        formatTo: 'dddd D, MMMM',
        date
      })
    },
    checkClick(e) {
      const includes = this.moveFixtures.findIndex(id => id === e)
      if (includes === -1) {
        this.moveFixtures.push(e)
      } else {
        this.moveFixtures.splice(includes, 1)
      }
    },
    getTeamImage(iconSrc) {
      return iconSrc === 'Not available in Demo' || iconSrc === null
        ? require('@/assets/profile-avatar.svg')
        : iconSrc
    },
    convertTimeStamp(data) {
      const { original, local, dayDiff, isSame, numSign } = formatTimestamp({
        timestamp: data,
        formatTo: 'HH:mm'
      })
      const localTimeDisplay = `(${local}) ${
        dayDiff === 0 ? '' : numSign + dayDiff
      }`
      return {
        original,
        local: isSame ? '' : localTimeDisplay
      }
    },
    clearData() {
      this.displayFixtures = null
      this.moveFixtures = []
    },
    moveGameButtonClick() {
      this.moveGameDialog = true
    },
    setRounds(data) {
      const filteredRounds = data.pages.filter(
        page => page.label >= data.ongoingRound
      )
      this.rounds = filteredRounds
    },
    moveGameDialogButtonClick() {
      this.moveGameDialog = false
      if (this.moveFixtures.length) {
        if (this.chosenRound) {
          this.moveFixturesRequest({
            fixtures: this.moveFixtures,
            moveTo: this.chosenRound
          }).then(() => {
            this.moveGameResponseDialogText = this.moveFixturesResponse.message
            this.moveGameResponseDialog = true
          })
        } else {
          this.moveGameResponseDialogText = 'You did not choose round number'
          this.moveGameResponseDialog = true
        }
      } else {
        this.moveGameResponseDialogText = 'There is no fixture selected'
        this.moveGameResponseDialog = true
      }
    },
    moveGameResponseDialogButtonClick() {
      this.moveGameResponseDialog = false
      if (this.moveFixturesResponse && this.moveFixturesResponse.success) {
        this.$router.go()
      }
    },
    roundChange(value) {
      this.chosenRound = value
    },
    fixtureStatusChecker(status, option) {
      if (option) {
        if (option === 'postponed') {
          return status === 'PST'
        } else if (option === 'not started') {
          return status === 'NS'
        } else {
          throw new Error('Invalid option')
        }
      }
      return status === 'PST' || status === 'NS'
    }
  },
  watch: {
    pageArr(data) {
      const pageList = data.pages
      this.setRounds(data)
      const roundId =
        parseInt(this.roundId) || pageList.find(item => item.defaultPage).param
      this.fetchRoundFixtures(roundId).then(() => {
        let compressFixtures = {}
        this.roundFixtures.data.forEach(fixture => {
          const date = formatTimestamp({
            formatTo: 'YYYY-MM-DD',
            timestamp: fixture.event_timestamp
          })
          const key = Object.keys(compressFixtures).find(
            x => x === date.original
          )
          if (!key) {
            compressFixtures[date.original] = []
          }
          compressFixtures[date.original].push(fixture)
        })
        this.displayFixtures = compressFixtures
      })
    },
    selectToggle() {
      if (!this.selectToggle) {
        this.moveFixtures = []
        this.$store.commit('SET_SHOW_SELECT_BUTTON', {
          show: true,
          label: 'Select'
        })
      }
    },
    triggerMoveButton() {
      if (this.triggerMoveButton) {
        this.$refs.moveGameButton.$children[0].$el.click()
        this.$store.commit('admin/SET_TRIGGER_MOVE_BUTTON', false)
      }
    }
  },
  deactivated() {
    this.clearData()
    this.$store.commit('SET_SHOW_SELECT_BUTTON', {
      show: true,
      label: 'Select'
    })
    this.$store.commit('SET_SHOW_CANCEL_BUTTON', false)
    this.setSelectToggle(false)
  }
}
